module.exports = __webpack_public_path__ + "static/media/MU.cc54b10d.png";